"use client";

/**
 * Instrumentación de diagnóstico de WebSocket (change fix-remote-session-ws,
 * design D1). Se activa SOLO con `?debug=ws` en la URL; sin el flag no
 * instala nada (coste cero en prod). Etiqueta cada socket con id secuencial
 * y registra constructor/open/close/send con código y timing.
 */

let installed = false;

export function ensureWsLog(): void {
  if (typeof window === "undefined" || installed) return;
  if (new URLSearchParams(window.location.search).get("debug") !== "ws") return;
  installed = true;

  const Native = window.WebSocket;
  const t0 = performance.now();
  let counter = 0;
  const now = () => `t=+${(performance.now() - t0).toFixed(1)}`;

  window.WebSocket = class extends Native {
    constructor(url: string | URL, protocols?: string | string[]) {
      super(url, protocols);
      const id = `ws:${++counter}`;
      // Never log protocols (the session ticket) or payload contents
      // (Guacamole keystrokes / terminal input): opcode and length only.
      const protocolCount = Array.isArray(protocols)
        ? protocols.length
        : protocols
          ? 1
          : 0;
      console.debug(
        `[${id}] CONSTRUCTOR url=${String(url)} protocol_count=${protocolCount} ${now()}`,
      );

      const origClose = this.close.bind(this);
      this.close = ((code?: number, reason?: string) => {
        console.debug(`[${id}] CLOSE local() code=${String(code ?? "?")} ${now()}`);
        return origClose(code, reason);
      }) as typeof this.close;

      const origSend = this.send.bind(this);
      this.send = ((data) => {
        const length =
          typeof data === "string"
            ? data.length
            : data instanceof ArrayBuffer
              ? data.byteLength
              : -1;
        console.debug(`[${id}] SEND bytes=${length} ${now()}`);
        return origSend(data);
      }) as typeof this.send;

      this.addEventListener("open", () => {
        console.debug(`[${id}] OPEN fired ${now()}`);
      });
      this.addEventListener("error", () => {
        console.debug(`[${id}] ERROR ${now()}`);
      });
      this.addEventListener("close", (ev: CloseEvent) => {
        console.debug(
          `[${id}] CLOSE code=${ev.code} reason=${ev.reason} clean=${ev.wasClean} ${now()}`,
        );
      });
    }
  };
}